import { render, staticRenderFns } from "./TimelineComponent.vue?vue&type=template&id=660a0651&scoped=true"
import script from "./TimelineComponent.vue?vue&type=script&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&lang=js"
import style0 from "./TimelineComponent.vue?vue&type=style&index=0&id=660a0651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a0651",
  null
  
)

export default component.exports